import React, { useEffect, useRef } from "react";
import { Nullable } from "../../../../common/types";
import colors from "../../../../common/styles/colors";

const classes = {
  input: {
    border: "none",
    outline: "none",
    color: colors.white,
    background: 'transparent'
  }
};

type Props = {
  onScannerInputChange: (evt: React.ChangeEvent<HTMLInputElement>) => void;
};

export const ScannerInput = ({ onScannerInputChange }: Props) => {
  const focusInterval = useRef<NodeJS.Timeout>();
  const inputRef = useRef<Nullable<HTMLInputElement>>(null);

  const setupFocusInterval = () => {
    inputRef.current?.focus();
    // Input needs to be focused all the time as scanner input will be typed in it.
    focusInterval.current = setInterval(() => {
      if (document.activeElement !== inputRef.current) {
        inputRef.current?.focus();
      }
    }, 2000);
  }

  useEffect(() => {
    setupFocusInterval();
    return () => {
      clearInterval(focusInterval.current!);
    };
  }, []);

  return (
    <div>
      <input
        style={process.env.REACT_APP_ENVIRONMENT === 'prod' ? classes.input : undefined}
        ref={inputRef}
        data-testid="scanner-input"
        inputMode="none"
        key="input"
        type="text"
        autoFocus
        onChange={onScannerInputChange}
      />
    </div>
  );
};
